var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisposableEmailChecker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#81b673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#438844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006838"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.23229 68.66375 71.23229 41.46494 56.41175 52.69981 71.23229 68.66375"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "28.76771 41.46501 28.76771 68.66391 43.58828 52.69991 28.76771 41.46501"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.47718,54.92439l-2.37038,1.79689c-.3272.24795-.71702.37219-1.10684.37219s-.77965-.12423-1.10684-.37219l-2.37022-1.79677-15.25513,16.43205h37.46465l-15.25523-16.43217Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "56.36511 30.19446 49.99994 25.36926 43.63477 30.19446 56.36511 30.19446"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.39539,33.46527v9.07489l15.60455,11.48608,15.60455-11.48608v-9.07489h-31.20911ZM48.92108,46.72583l-5.30804-5.30945,1.99634-1.9964,3.15594,3.15588,5.48041-6.3717,2.14111,1.84058-7.46576,8.68109Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisposableEmailChecker);
export default __webpack_public_path__ + "static/media/disposable-email-checker.f90133129f301717816ccb665fdb01c2.svg";
export { ForwardRef as ReactComponent };